import {
  InlineRefResolverProvider,
  NonIdealState,
  withMosaicProvider,
  withPersistenceBoundary,
  withQueryClientProvider,
  withRouter,
  withStyles,
} from "@stoplight/elements-core";
import { Flex } from "@stoplight/mosaic";
import { flow } from "lodash";
import * as React from "react";
import { Document } from "components/Document";
import { APIProps } from "./types";
import { useDocument } from "hooks/useDocument";

export const APIImpl: React.FC<APIProps> = () => {
  const { error, exportProps, isLoading, nodes, parsedDocument } =
    useDocument();

  if (error) {
    return (
      <Flex justify="center" alignItems="center" w="full" minH="screen">
        <NonIdealState
          title="Document could not be loaded"
          description="The Home description document could not be fetched. This could indicate connectivity problems, or issues with the server hosting the spec."
          icon="exclamation-triangle"
        />
      </Flex>
    );
  }

  if (isLoading) {
    return (
      <Flex justify="center" alignItems="center" w="full" minH="screen">
        <NonIdealState
          title="Loading OpenAPI files"
          description="We're building the buildings as fast as we can"
          icon={"circle"}
        />
      </Flex>
    );
  }

  if (!nodes) {
    return null;
  }

  return (
    <InlineRefResolverProvider document={parsedDocument}>
      <Document
        serviceNode={nodes}
        hideInternal={false}
        exportProps={exportProps}
      />
    </InlineRefResolverProvider>
  );
};

export const Home = flow(
  withRouter,
  withStyles,
  withPersistenceBoundary,
  withMosaicProvider,
  withQueryClientProvider
)(APIImpl);
